<script>
import { mapState, mapActions } from 'vuex';
import enquire from 'enquire.js';

export default {
    data() {
        return {
            showResources: true,
            showShortcuts: false,
        };
    },
    mounted() {
        const self = this;
        enquire.register('screen and (min-width: 1173px)', {
            match() {
                self.showResources = true;
                self.showShortcuts = true;
            },
            unmatch() {
                self.showResources = true;
                self.showShortcuts = false;
            },
        });
    },
    computed: {
        ...mapState(['showRemoteMenu']),
    },
    methods: {
        ...mapActions(['toggleRemoteMenu']),
        swapTabs() {
            this.showResources = !this.showResources;
            this.showShortcuts = !this.showShortcuts;
        },
    },
};
</script>
